import { ApiBaseFront } from '../../front/api-base-front';

export type PrintStatusList = {
  kijshopCd: string,
  shopOrderId: string,
  lastName: string,
  status: string,
  note: string,
  lastUpdateDate: string,
  orderDate: string,
  orderCompleteDate: string,
  orderUser: string,
  createDate: string,
  lockUser: string,
  centerShippinDate: string,
  // コピーして新規で作成された注文のコピー元注文番号(通常注文は未設定)
  copySrcShopOrderId?: string | null,
}[]

export type PrintShopOrderStatusListGetResponse = {
  data: PrintStatusList,
};

// export type ShopOrderListGetResponseStatus = {
//   shopOrderIdList: ShopOrderListGetResponse[],
//   // statusList: ShopOrderListGetResponse[],
// };
//
export class ApiPrintShopOrderStatusListGet extends ApiBaseFront<PrintShopOrderStatusListGetResponse> {
  constructor(kijShopCd: string) {
    super(
      'GET',
      `/api/v1/print/shop/${kijShopCd}/meta/shopOrder`,
      'JSON',
      {},
    );
  }
}

export type ShopOrderListGetResponseStatus = PrintShopOrderStatusListGetResponse;

export class ApiShopOrderListGet extends ApiBaseFront<ShopOrderListGetResponseStatus> {
  constructor(kijshopCd: string) {
    super(
      'GET',
      `/api/v1/orderxml/${kijshopCd}/status`,
      'JSON',
      // { is_first: '1' },
      {},
    );
  }
}

export type ShopOrderListSortGetRequest = {
  kijshopCd: string,
  date_kind?: string,
  date_start?: string,
  date_end?: string,
  lastName?: string,
  shopOrderId?: string,
  status?: string,
  sort_by?: string,
  highlow?: string,
  is_first?: string,
};

export class ApiShopOrderListSortGet extends ApiBaseFront<ShopOrderListGetResponseStatus> {
  constructor(_param: ShopOrderListSortGetRequest) {
    const { kijshopCd } = _param;
    super(
      'GET',
      `/api/v1/orderxml/${kijshopCd}/status`,
      'JSON',
      {},
    );
  }
}
